import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckPersonAccessEventQueryVariables = Types.Exact<{
  input: Types.CheckPersonAccessEventInput;
}>;

export type CheckPersonAccessEventQuery = {
  __typename?: 'Query';
  checkPersonAccessEvent: {
    __typename?: 'CheckPersonAccessEventResponse';
    accessible: boolean;
  };
};

export const CheckPersonAccessEventDocument = gql`
  query CheckPersonAccessEvent($input: CheckPersonAccessEventInput!) {
    checkPersonAccessEvent(input: $input) {
      accessible
    }
  }
`;
export function useCheckPersonAccessEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  > &
    (
      | { variables: CheckPersonAccessEventQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  >(CheckPersonAccessEventDocument, options);
}
export function useCheckPersonAccessEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  >(CheckPersonAccessEventDocument, options);
}
export function useCheckPersonAccessEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckPersonAccessEventQuery,
        CheckPersonAccessEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  >(CheckPersonAccessEventDocument, options);
}
export type CheckPersonAccessEventQueryHookResult = ReturnType<
  typeof useCheckPersonAccessEventQuery
>;
export type CheckPersonAccessEventLazyQueryHookResult = ReturnType<
  typeof useCheckPersonAccessEventLazyQuery
>;
export type CheckPersonAccessEventSuspenseQueryHookResult = ReturnType<
  typeof useCheckPersonAccessEventSuspenseQuery
>;
export type CheckPersonAccessEventQueryResult = Apollo.QueryResult<
  CheckPersonAccessEventQuery,
  CheckPersonAccessEventQueryVariables
>;
export function refetchCheckPersonAccessEventQuery(
  variables: CheckPersonAccessEventQueryVariables,
) {
  return { query: CheckPersonAccessEventDocument, variables: variables };
}
